import { HawaPanel } from '../types'

import component from './gmap.component.vue'
import editor from './gmap.editor.vue'
// import { Attribute } from './types'

export default class GoogleMap implements HawaPanel {
  name = 'GoogleMap'
  title = 'Google Map'
  component = component
  editor = editor
  snapshot = {
    DeletedAt: null,
    title: 'Google Map',
    component: 'GoogleMap',
    query: [],
    layout: { h: 9, i: '1597804192412', moved: false, w: 16, x: 16, y: 18 },
    attributes: {
      map: {
        center: {
          lat: -5.886284,
          lng: 106.067626,
        },
        markers: [
          {
            position: { lat: -5.883591, lng: 106.06928 },
            title: 'Hello',
            draggable: false,
          },
        ],
      },
      panelHeader: {
        show: false,
        style: {},
      },
      headerShow: true,
      labelTextStyle: {
        'vertical-align': 'middle',
      },
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '30px',
        padding: '10px',
        'text-align': 'left',
        width: '180px',
      },
      labelText: '<b>T</b>ext',
    },
  }

  init = {
    DeletedAt: null,
    title: 'Google Map',
    component: 'GoogleMap',
    query: [],
    layout: { h: 30, i: '1597804192412', moved: false, w: 240, x: 16, y: 18 },
    attributes: {
      map: {
        center: {
          lat: -5.886284,
          lng: 106.067626,
        },
        markers: [
          {
            tag: 'pzj9dsHGz',
            subTitle: 'Electrolizer B Expansi Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230A',
            lat: -5.884953,
            lng: 106.069083,
          },
          {
            tag: 'wth6dsNGk',
            subTitle: 'Electrolizer B Expansi Area_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230A',
            lat: -5.884931,
            lng: 106.069147,
          },
          {
            tag: '2-AzKyHMk',
            subTitle: 'Electrolizer D Expansi Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230B',
            lat: -5.884937,
            lng: 106.06924,
          },
          {
            tag: '8jxWKyNGz',
            subTitle: 'Electrolizer D Expansi Area_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230B',
            lat: -5.884923,
            lng: 106.069305,
          },
          {
            tag: 'uMS7FsNGz',
            subTitle: 'Electrolizer F Expansi Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230C',
            lat: '',
            lng: '',
          },
          {
            tag: 'HbAVFyHGk',
            subTitle: 'Electrolizer F Expansi Area_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230C',
            lat: '',
            lng: '',
          },
          {
            tag: 'UstNKsNMz',
            subTitle: 'Electrolizer H Expansi Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230D',
            lat: '',
            lng: '',
          },
          {
            tag: 'OBSdKsHMk',
            subTitle: 'Electrolizer H Expansi Area_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230D',
            lat: '',
            lng: '',
          },
          {
            tag: 'y3K5KyHGz',
            subTitle: 'Electrolizer J Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230F',
            lat: '',
            lng: '',
          },
          {
            tag: 'oJJtFsNGk',
            subTitle: 'Electrolizer J Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230F',
            lat: '',
            lng: '',
          },
          {
            tag: 'IN_2KsNMz',
            subTitle: 'Electrolizer L Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230I',
            lat: '',
            lng: '',
          },
          {
            tag: '2xO0FsNMz',
            subTitle: 'Electrolizer L Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230I',
            lat: '',
            lng: '',
          },
          {
            tag: 'Dc_1FsHMk',
            subTitle: 'Electrolizer N Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230E',
            lat: '',
            lng: '',
          },
          {
            tag: 'j8JaKyNMz',
            subTitle: 'Electrolizer N Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230E',
            lat: '',
            lng: '',
          },
          {
            tag: 'cE-fKsHMz',
            subTitle: 'Electrolizer P Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230G',
            lat: '',
            lng: '',
          },
          {
            tag: 'wwQLFsNMz',
            subTitle: 'Electrolizer P Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230G',
            lat: '',
            lng: '',
          },
          {
            tag: 'FrpsFyNMk',
            subTitle: 'Electrolizer R Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2E230H',
            lat: '',
            lng: '',
          },
          {
            tag: 'dba8KyNMz',
            subTitle: 'Electrolizer R Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230H',
            lat: '',
            lng: '',
          },
          {
            tag: 'LabQFsNGz',
            subTitle: 'Electrolizer S Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2T230S',
            lat: '',
            lng: '',
          },
          {
            tag: 'L6w_KsHGk',
            subTitle: 'Electrolizer S Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230S',
            lat: '',
            lng: '',
          },
          {
            tag: 'uLuuKsHGk',
            subTitle: 'Electrolizer T Conversi_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2T230T',
            lat: '',
            lng: '',
          },
          {
            tag: 'E_q9KyHMk',
            subTitle: 'Electrolizer T Conversi_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'H2E230T',
            lat: '',
            lng: '',
          },
          {
            tag: '56SqFyHMk',
            subTitle: 'Gas Absorber T730 Hypo_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CL2T734',
            lat: '',
            lng: '',
          },
          {
            tag: 'qAI6FsHGz',
            subTitle: 'Gas Absorber T730 Hypo_SD-1 (H2)',
            draggable: 'FALSE',
            title: 'Hypo_SD-1',
            lat: '',
            lng: '',
          },
          {
            tag: 'J56R5sNMz',
            subTitle: 'SMI Selatan Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD206',
            lat: '',
            lng: '',
          },
          {
            tag: 'exii5sHMz',
            subTitle: 'SMI Utara Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD207',
            lat: '',
            lng: '',
          },
          {
            tag: 'uv6mcyHGz',
            subTitle: 'Hypo Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD202',
            lat: '',
            lng: '',
          },
          {
            tag: 'd5nGcyNGk',
            subTitle: 'HCl Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD201',
            lat: '',
            lng: '',
          },
          {
            tag: 'TO4n5sNMz',
            subTitle: 'Brine Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD203',
            lat: '',
            lng: '',
          },
          {
            tag: 'rcHVcyHMk',
            subTitle: 'Nitrogen Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD204',
            lat: '',
            lng: '',
          },
          {
            tag: 'c-QS5yHGk',
            subTitle: 'Liquid Ex. Cl2 Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD205',
            lat: '',
            lng: '',
          },
          {
            tag: '5ewN5yNMk',
            subTitle: 'Electrolizer Expansi Area_GD-K88Ai (CL2)',
            draggable: 'FALSE',
            title: 'CD208',
            lat: '',
            lng: '',
          },
        ],
      },
      panelHeader: {
        show: false,
        style: {},
      },
      headerShow: true,
      labelTextStyle: {
        'vertical-align': 'middle',
      },
      labelStyle: {
        'background-color': '#ffffff',
        border: '',
        color: '#0033ff',
        'font-size': '30px',
        padding: '0',
        'text-align': 'left',
        width: '100%',
      },
      labelText: '<b>T</b>ext',
    },
  }
}
